module.exports = __webpack_public_path__ + "files/e9ebb65c85f5ed8915640046ecd3acad.svg";